<template>
  <div>
    <v-data-table
      :headers="columns"
      :items="items"
      :search="search"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :filterable="filterable"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item.name }}</td>
        <td class="">{{ props.item.phone }}</td>
        <td class="">{{ props.item.email }}</td> -->
        <td v-for="(col, index, key) in columns" :key="key">
          {{ props.item[col.text] }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    props: {
      columns: {
        type: Array,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      filterable: {
        type: Boolean,
        default: false
      },
      sortable: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        search: '',
        loading: true,
        pagination: {}
      }
    },

    computed: {
      totalItems () {
        return this.items.length
      }
    },

    watch: {
      pagination: {
        handler (val) {
          // this.getdatafromapi()
          //   .then(data => {
          //     this.contacts = data.items
          //     this.totalcontacts = data.total
          //     this.columns = data.columns
          //   })
        },
        deep: true
      }
    },
    mounted () {
      // this.getDataFromApi()
      //   .then(data => {
      //     this.contacts = data.items
      //     this.totalContacts = data.total
      //     this.columns = data.columns
      //   })
    },
    methods: {
      // getDataFromApi () {
      //   this.loading = true
      //   return new Promise((resolve, reject) => {
      //     const { sortBy, descending, page, rowsPerPage } = this.pagination

      //     let items = this.getContacts()
      //     let columns = this.columns
      //     const total = items.length

      //     if (this.pagination.sortBy) {
      //       items = items.sort((a, b) => {
      //         const sortA = a[sortBy]
      //         const sortB = b[sortBy]

      //         if (descending) {
      //           if (sortA < sortB) return 1
      //           if (sortA > sortB) return -1
      //           return 0
      //         } else {
      //           if (sortA < sortB) return -1
      //           if (sortA > sortB) return 1
      //           return 0
      //         }
      //       })
      //     }

      //     if (rowsPerPage > 0) {
      //       items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
      //     }

      //     setTimeout(() => {
      //       this.loading = false
      //       resolve({
      //         items,
      //         total,
      //         columns
      //       })
      //     }, 1000)
      //   })
      // }
    }
  }
</script>